import { Button } from "@material-tailwind/react";
import React, { useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import SiteLogo from "../../assets/gassol logo.jpg";
import { FiEye, FiEyeOff } from "react-icons/fi";
import {
  base_url,
  mailPattern,
  phoneNumber,
  strongPwd,
} from "../../variables/constants";
import toast from "react-hot-toast";
import axios from "axios";

function DeliveryBoyDeleteUrl() {
  const [screen, setScreen] = useState({
    main_screen_before: true,
    main_screen_after: false,
  });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [fieldData, setFieldData] = useState({ username: "", password: "" });
  const [isValid, setIsValid] = useState({ username: false, password: false });

  const handleChange = (e) => {
    if (e.target.name === "username") {
      if (
        mailPattern.test(e.target.value) ||
        phoneNumber.test(e.target.value)
      ) {
        setIsValid({ ...isValid, username: true });
      } else {
        setIsValid({ ...isValid, username: false });
      }
    } else if (e.target.name === "password") {
      if (strongPwd.test(e.target.value)) {
        setIsValid({ ...isValid, password: true });
      } else {
        setIsValid({ ...isValid, password: false });
      }
    }
    setFieldData({ ...fieldData, [e.target.name]: e.target.value });
  };

  const handleDeleteDeliveryBoy = async (e) => {
    e.preventDefault();

    if (!isValid.username) {
      toast.error("Please enter a valid username");
    } else if (!isValid.password) {
      toast.error(
        "Password must have atleast 1 lowercase, number, special characters and minimum 8 characters."
      );
    } else {
      let finalUsername = fieldData.username;

      // Check if the username is a phone number and add +91 prefix if not already present
      if (phoneNumber.test(finalUsername)) {
        if (!finalUsername.startsWith("+91")) {
          finalUsername = `+91${finalUsername}`;
        }
      }

      // Update fieldData with the formatted username before submitting
      const updatedFieldData = { ...fieldData, username: finalUsername };

      try {
        const res = await axios.delete(`${base_url}/api/delete/my/account/`, {
          data: {
            username: updatedFieldData.username,
            password: fieldData.password,
          },
        });
        if (res.data.responseCode === 200) {
          setScreen({
            ...screen,
            main_screen_before: false,
            main_screen_after: true,
          });
        } else {
          toast.error(res.data.responseMessage);
        }
      } catch (error) {
        toast.error(error);
      }
    }
  };

  const handleBackClick = () => {
    setScreen({
      ...screen,
      main_screen_before: true,
      main_screen_after: false,
    });
    setFieldData({ ...fieldData, username: "", password: "" });
  };

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <>
      <div className="h-screen w-screen flex justify-center items-center bg-white">
        <div className="bg-white flex flex-col w-11/12 sm:w-4/5 md:flex-row md:w-11/12 lg:w-4/5 2xl:w-3/5 drop-shadow-xl">
          <div className="flex justify-center flex-col items-center w-full p-10 gap-4 bg-gray-200">
            <img src={SiteLogo} alt="Site logo" className="w-1/4" />
            <h1 className="text-3xl sm:text-4xl font-semibold text-[#03438D] text-center">
              Gassol Monitor Right
            </h1>
          </div>

          <div className="flex justify-center flex-col items-center w-full bg-[#03438D] text-white p-10">
            <div>
              {screen.main_screen_before && (
                <form
                  onSubmit={handleDeleteDeliveryBoy}
                  className="flex flex-col gap-4"
                >
                  <h1 className="text-3xl sm:text-4xl font-semibold">
                    Delete Account
                  </h1>
                  <p>
                    Deleting your account will remove all of your information
                    from our database. This cannot be undone.
                  </p>

                  <>
                    <input
                      type="text"
                      name="username"
                      className="w-full bg-[#F5F7F9] px-7 py-6 outline-none border-none rounded-2xl text-[#8f8f8f]"
                      placeholder="Enter your Email ID / Phone No."
                      value={fieldData.username}
                      onChange={handleChange}
                      required
                    />

                    <div className="relative">
                      <input
                        className="w-full bg-[#F5F7F9] pl-7 pr-12 py-6 outline-none border-none rounded-2xl text-[#8f8f8f]"
                        type={isPasswordVisible ? "text" : "password"}
                        name="password"
                        placeholder="Password *"
                        value={fieldData.password}
                        onChange={handleChange}
                        required
                      />
                      {isPasswordVisible ? (
                        <FiEyeOff
                          onClick={togglePasswordVisibility}
                          className="absolute right-5 top-1/2 transform -translate-y-1/2 text-[#8f8f8f] cursor-pointer"
                        />
                      ) : (
                        <FiEye
                          onClick={togglePasswordVisibility}
                          className="absolute right-5 top-1/2 transform -translate-y-1/2 text-[#8f8f8f] cursor-pointer"
                        />
                      )}
                    </div>
                  </>

                  <div className="flex justify-end items-center">
                    <Button
                      type="submit"
                      className="bg-[#fff] text-[#03438D] font-poppins tracking-widest px-8 py-3 rounded-lg outline-none active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out disabled:cursor-not-allowed disabled:bg-slate-500"
                    >
                      Delete Account
                    </Button>
                  </div>
                </form>
              )}

              {screen.main_screen_after && (
                <div className="flex flex-col gap-4">
                  <h1 className="text-3xl sm:text-4xl font-semibold">
                    Your Account has been deleted successully.
                  </h1>
                  <div className="flex justify-end items-center">
                    <Button
                      onClick={handleBackClick}
                      className="flex items-center bg-white text-[#03438D] font-poppins tracking-wider gap-2 px-8 py-2 outline-none active:scale-[.98] border border-white rounded-lg active:duration-75 transition-all hover:scale-[1.01] ease-in-out disabled:cursor-not-allowed disabled:bg-slate-500"
                    >
                      <IoMdArrowBack /> Back
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DeliveryBoyDeleteUrl;
